
// js/common/feedback/toast.js
import { animate as animate6 } from "vendor";
var _Toast_instances, onShow_fn;
var CustomToast = class extends HTMLElement { 
    constructor() {
        super(...arguments);
        __privateAdd(this, _Toast_instances);
    }
    connectedCallback() {
        document.addEventListener("toast:show", __privateMethod(this, _Toast_instances, onShow_fn).bind(this));
    }
};
_Toast_instances = new WeakSet();
onShow_fn = function (event) { 
    const images = event?.target?.images;
    let image = null;

    if (images) {
        const lineItemImages = Array.from(images).filter(img =>
            img.classList.contains('line-item__media-image')
        );
        image = lineItemImages.at(0);
    }

    const messageFragment = document.createRange().createContextualFragment(`
        <div class="toast__message h-stack gap-4 ${event.detail?.tone === "error" ? "toast__message--error" : ""}">
            ${image ? `<img src="${image.src}" class="${image ? "" : "shimmer"} ${event.detail?.tone == "error" && "hidden"} toast__image" alt="">` : ""}
            <div class="toast__right text--left h-full items-between justify-between gap-4">
                <div class="toast__text">${event.detail.message}</div>
                <span class="toast__go-to-cart link" aria-controls="cart-drawer">
                    ${window.themeVariables.strings.goToCart}
                </span>
                <span class="toast__close cursor-pointer">
                    <svg aria-hidden="true" focusable="false" width="10" part="icon" fill="none" viewBox="0 0 10 10">
                        <path stroke="currentColor" d="m1 1 8 8m0-8L1 9" />
                    </svg>
                </span> 
            </div>
        </div>
    `);

    const messageElement = messageFragment.querySelector('.toast__message');
    this.replaceChildren(messageElement);

    // Fade-in animation
    animate6(messageElement, { opacity: [0, 1], transform: ["translateY(20px)", "translateY(0)"] }, {
        duration: 0.25,
        ease: "easeInOut"
    });

    // Add click listeners to remove the message early
    messageElement.querySelector('.toast__close')?.addEventListener('click', () => {
        messageElement.remove();
    });

    messageElement.querySelector('.toast__go-to-cart')?.addEventListener('click', () => {
        messageElement.remove();
    });

    // Auto-remove after timeout
    setTimeout(async () => {
        await animate6(messageElement, { opacity: [1, 0], transform: ["scale(1)", "scale(0.85)"] }, {
            duration: 0.25,
            ease: "easeInOut"
        });
        messageElement.remove();
    }, event.detail?.duration || 2500);
};



if (!window.customElements.get("x-toast-custom")) {
    window.customElements.define("x-toast-custom", CustomToast);
}